<!--  -->
<template>
  <div class="tablwbox">
    <div class="srrwrw">
      <el-input
        v-model="paquery.keyword"
        placeholder="请输入小程序名/appid"
        style="width:200px;margin-right:10px"
      />
      <el-select
        v-model="paquery.mini_program_type"
        placeholder="请选择小程序类型"
      >
        <el-option
          v-for="item in options"
          :key="item.mini_program_type"
          :label="item.type_name"
          :value="item.mini_program_type"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left:10px"
        @click="srarch"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh"
        @click="reset"
      >重置</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="app_id"
        label="公众号appid"
        width="160"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="公众号/小程序名称"
        width="150"
        align="center"
      />
      <el-table-column
        prop="address"
        label="头像"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.head_img"
            alt=""
            style="width:80px;height:80px"
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="user_name"
        label="原始 ID"
        width="150"
        align="center"
      />
      <el-table-column
        prop="principal_name"
        label="主体名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="group_name"
        label="运营组"
        width="150"
        align="center"
      />
      <el-table-column
        prop="qrcode_url"
        label="二维码图片"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.qrcode_url"
            alt=""
            style="width:80px;height:80px"
            @click="enlarge(scope.row.qrcode_url)"
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="mini_program_text"
        label="小程序类型"
        width="150"
        align="center"
      />
      <el-table-column
        prop="mini_program_text"
        label="是否跳转小游戏"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.open_jump_game"
            active-text="开"
            inactive-text="关"
            :active-value="1"
            :inactive-value="2"
            @change="dawr(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="fans_number"
        label="粉丝数"
        width="80"
        align="center"
      />
      <el-table-column
        prop="admin_name"
        label="管理员"
        width="80"
        align="center"
      />
      <el-table-column
        prop="operation_status_text"
        label="运营状态"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <i
            v-if="scope.row.operation_status == 1"
            class="el-icon-success defaultr"
          />
          <i
            v-if="scope.row.operation_status == 2"
            class="el-icon-warning"
          />
          <i
            v-if="scope.row.operation_status == 3"
            class="el-icon-error stopew"
          />
          <i
            v-if="scope.row.operation_status == 4"
            class="el-icon-warning"
          />
          {{ scope.row.operation_status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="alias"
        label="微信号"
        width="150"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="150"
        align="center"
      />
      <!-- <el-table-column
        prop="status_text"
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          <i
            v-if="scope.row.status == 1"
            class="el-icon-warning defaultrse"
          />
          <i
            v-if="scope.row.status == 2"
            class="el-icon-success defaultr"
          />
          <i
            v-if="scope.row.status == 3"
            class="el-icon-error stopew"
          />
          <i
            v-if="scope.row.status == 4"
            class="el-icon-warning"
          />
          {{ scope.row.operation_status_text }}
        </template>
      </el-table-column> -->
      <el-table-column
        prop="status_text"
        label="操作"
        align="center"
        fixed="right"
        width="300"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            style="color: #1890ff;"
            @click="addgroup(scope.row)"
          >添加运营组</el-button>
          <el-button
            size="mini"
            type="text"
            style="color: #ffba00;"
            @click="editwechat(scope.row)"
          >修改小程序类型</el-button>
          <el-button
            size="mini"
            type="text"
            style="color: #13ce66;"
            @click="editopstatus(scope.row)"
          >修改小程序运营状态</el-button>
          <el-button
            size="mini"
            type="text"
            style="color: #1890ff;"
            @click="generatelink(scope.row)"
          >生成链接地址</el-button>
          <el-button
            size="mini"
            type="text"
            style="color: #ffba00;"
            @click="lookdata(scope.row)"
          >访问数据</el-button>
          <el-button
            size="mini"
            type="text"
            style="color: #13ce66;"
            @click="lookma(scope.row)"
          >体验版二维码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="二维码"
      :visible.sync="dialogVisible"
      width="20%"
    >
      <div style="text-align:center">
        <img
          :src="qrcode"
          alt=""
          style="width:300px;height:300px;"
        >
      </div>

    </el-dialog>
    <el-dialog
      title="添加运营组"
      :visible.sync="dialogVisiblegroup"
      width="800px"
    >
      <group
        ref="add"
        @friendband="friendband"
      />
    </el-dialog>
    <el-dialog
      title="生成链接地址"
      :visible.sync="dialogVisiblelink"
      :destroy-on-close="true"
      width="50%"
    >
      <addlink
        ref="addlinkview"
        @updatalink="updatalink"
      />
    </el-dialog>

    <el-dialog
      title="修改小程序"
      :visible.sync="dialogVisiblewechat"
      width="15%"
    >
      <el-select
        v-model="mini_program_type"
        placeholder="请选择小程序类型"
      >
        <el-option
          v-for="item in options"
          :key="item.mini_program_type"
          :label="item.type_name"
          :value="item.mini_program_type"
        />
      </el-select>
      <div style="margin-top:80px;margin-left: 150px;">
        <el-button
          type="primary"
          @click="suwrwecaht"
        >确定</el-button>
      </div>

    </el-dialog>
    <el-dialog
      title="修改运营状态"
      :visible.sync="dialogVisibleopstatus"
      width="15%"
    >
      <el-select
        v-model="operation_status"
        placeholder="请选择运营状态"
      >
        <el-option
          v-for="item in optionsoparr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <div style="margin-top:80px;margin-left: 150px;">
        <el-button
          type="primary"
          @click="sumbitrop"
        >确定</el-button>
      </div>

    </el-dialog>
    <el-dialog
      title="体验版二维码"
      :visible.sync="dialogVisiblelook"
      width="30%"
    >
      <div style="text-align: center;">
        <img v-if="maimg" :src="maimg" style="width:200px;height:200px" alt="">
      </div>

    </el-dialog>
    <pagination-right
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
  </div>
</template>

<script>
import {
  appletlistrw,
  mptypeslist,
  officialupdateMpType,
  addOpGroup,
  officialAccountupdOperationStatus,
  gettemplater
} from '@/api/sourceMaterial.js'
import { officialAccountopenJumpGame } from '@/api/sourceminiprogram.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import group from './components/group.vue'
import addlink from './components/addlink.vue'
export default {
  components: {
    PaginationRight,
    group,
    addlink
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisiblelook: false,
      maimg: null,
      dialogVisiblegroup: false,
      paquery: {
        page: 1,
        page_size: 10,
        keyword: null,
        mini_program_type: null
      },
      total: null,
      tableData: [],
      options: [],
      qrcode: '',
      mini_program_type: null,
      dialogVisiblewechat: false,
      app_id: '',
      dialogVisibleopstatus: false,
      operation_status: null,
      optionsoparr: [
        {
          value: 1,
          label: '在跑'
        },
        {
          value: 2,
          label: '停跑'
        },
        {
          value: 3,
          label: '永封'
        },
        {
          value: 4,
          label: '警告'
        }
      ],
      dialogVisiblelink: false
    }
  },
  created() {
    this.sawrlist()
    this.getapplettype()
  },
  mounted() {},
  methods: {
    async getapplettype() {
      const data = await mptypeslist()
      this.options = data.data.types
      console.log('data', data)
    },
    async sawrlist() {
      const data = await appletlistrw(this.paquery)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    fetchPageSizeone(e) {
      this.paquery.page_size = e
      this.sawrlist()
    },
    fetchCurrentPageone(e) {
      this.paquery.page = e
      this.sawrlist()
    },
    srarch() {
      this.paquery.page = 1
      this.sawrlist()
    },
    reset() {
      this.paquery.page = 1
      this.paquery.page_size = 10
      this.paquery.keyword = null
      this.paquery.mini_program_type = null
      this.sawrlist()
    },
    enlarge(url) {
      this.qrcode = url
      this.dialogVisible = true
    },
    editwechat(item) {
      this.dialogVisiblewechat = true
      this.mini_program_type = item.mini_program_type
      this.app_id = item.app_id
      console.log(item)
    },
    editopstatus(item) {
      this.dialogVisibleopstatus = true
      this.operation_status = item.operation_status
      this.app_id = item.app_id
    },
    addgroup(item) {
      this.dialogVisiblegroup = true
      this.$nextTick(() => {
        console.log('item:', item)
        this.$refs.add.sendr(item)
      })
    },
    async friendband(row, item) {
      await addOpGroup({
        app_id: item.app_id,
        admin_group_id: row.id
      })
      this.$message.success(`添加${row.title}成功`)
      this.dialogVisiblegroup = false
      this.sawrlist()
    },
    async suwrwecaht() {
      const data = await officialupdateMpType({
        app_id: this.app_id,
        mini_program_type: this.mini_program_type
      })
      console.log('data', data)
      this.dialogVisiblewechat = false
      this.sawrlist()
      this.$message({
        message: '修改成功',
        type: 'success'
      })
    },
    async sumbitrop() {
      const data = await officialAccountupdOperationStatus({
        app_id: this.app_id,
        operation_status: this.operation_status
      })
      console.log('data', data)
      this.dialogVisibleopstatus = false
      this.sawrlist()
      this.$message({
        message: '修改成功',
        type: 'success'
      })
    },
    async dawr(item) {
      console.log('item', item)
      const data = await officialAccountopenJumpGame({
        app_id: item.app_id,
        open_jump_game: item.open_jump_game
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.sawrlist()
      console.log('data', data)
    },
    generatelink(item) {
      console.log(item)
      this.dialogVisiblelink = true
      this.$nextTick(() => {
        this.$refs.addlinkview.send(item.app_id)
      })
    },
    updatalink() {
      this.dialogVisiblelink = false
    },
    lookdata(item) {
      console.log(item)
      this.$router.push({
        path: '/miniprogramoption/miniprogramaccess',
        query: {
          appid: item.app_id
        }
      })
    },
    async lookma(item) {
      this.dialogVisiblelook = true
      const data = await gettemplater({
        app_id: item.app_id
      })
      console.log('data', data)
      this.maimg = data.data.qrcode
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tablwbox {
  padding: 20px;
}
.srrwrw {
  margin-bottom: 10px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
</style>
